// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1P8Qc","alertIcon":"ConfirmModal_alertIcon__2225j"};